import React from 'react';
import { getColor } from 'core/utils/Styles';
import PropTypes from 'prop-types';

const ThumbsUp = props => (
	<svg width="1em" height="1em" viewBox="0 0 12 12" {...props}>
		<path d="M9.956 4.5H6.731v-3a1.314 1.314 0 0 0-1.5-1.5.5.5 0 0 0-.45.375L3 6v6h6.431c.985-.02 1.81-.75 1.95-1.725l.6-3.45a1.9 1.9 0 0 0-.45-1.575 1.884 1.884 0 0 0-1.575-.75zM0 6h2v6H0z" />
	</svg>
);

ThumbsUp.propTypes = {
	fill: PropTypes.string,
};

ThumbsUp.defaultProps = {
	fill: getColor('primaryBrand'),
};

export default ThumbsUp;
